const normalizeValue = (value) => (value ?? '').toString().trim();

// Asks the backend duplicate-check endpoint for each cut that has a street number (address).
// `checkDuplicate` is `api.checkProjectDuplicate`: ({ workOrderNumber, address, client })
// => Promise<{ duplicate, projects }>. Returns details of the first matching cut, or
// null when nothing matches (or there isn't enough info to check).
export async function findProjectDuplicate(values, checkDuplicate) {
    const workOrderNumber = normalizeValue(values?.workOrderNumber);
    const client = normalizeValue(values?.client?.id);

    // The endpoint matches on work order number + street number + client; without a work
    // order number or client there's nothing to check.
    if (!workOrderNumber || !client) {
        return null;
    }

    for (const cut of values?.cuts ?? []) {
        const address = normalizeValue(cut?.address);
        const street = normalizeValue(cut?.street);

        if (!address) {
            continue;
        }

        const result = await checkDuplicate({ workOrderNumber, address, client });

        if (result?.duplicate) {
            return {
                // Match is on street number only, but show the full street for context.
                address: `${address} ${street}`.trim(),
                projects: result?.projects ?? [],
            };
        }
    }

    return null;
}